/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { FC, useState } from 'react';
import { BasicInput } from '../../shared/inputs/BasicInput';
import * as yup from 'yup';
import { BasicButtonSelectionInput } from '../../shared/inputs/BasicButtonSelectionInput';
import { emailDefaultToneOptions } from '../editorPage/forms/formInputs/DefaultOptions';
import { BoxedAutoResizeTextarea } from '../../shared/inputs/BoxedAutoResizeTextarea';
import { BasicButton } from '../../shared/buttons/BasicButton';
import CreatableSelect from 'react-select/creatable';
import styles from './BrandPersonaPopupSolo.module.css';
import Image from 'next/image';
import { usePersonaContext } from '../../../contexts/PersonaContext';
import { v4 as uuid } from 'uuid';
import mixpanel from 'mixpanel-browser';
import { useAuthContext } from '../../../contexts/AuthContext';
import { BrandDictionary } from './BrandDictionary';
import { replacementWords } from '../../../types/Persona.type';
import Tooltip from '../../shared/tooltips/Tooltip';
interface Option {
  readonly label: string;
  readonly value: string;
}

const createOption = (label: string) => ({
  label,
  value: label,
});

const defaultOptions = [
  createOption('Advertising and Marketing'),
  createOption('Aerospace'),
  createOption('Agriculture'),
  createOption('Computer and Technology'),
  createOption('Construction'),
  createOption('Education'),
  createOption('Energy'),
  createOption('Entertainment'),
  createOption('Fashion'),
  createOption('Finance and Economic'),
  createOption('Food and Beverage'),
  createOption('Health Care'),
  createOption('Hospitality'),
  createOption('Manufacturing'),
  createOption('Media and News'),
  createOption('Mining'),
  createOption('Pharmaceutical'),
  createOption('Telecommunication'),
  createOption('Transportation'),
];

interface Props {
  onClose: () => void;
}

export const BrandPersonaSoloPopup: FC<Props> = ({ onClose }) => {
  // const [roleValue, setRoleValue] = useState('')
  const [loading, setLoading] = useState(false);
  const [successfulBrandSaved, setSuccessfulBrandSaved] = useState(false);
  const [options, setOptions] = useState(defaultOptions);
  const [value, setValue] = useState<Option | null>();
  const [filebase64, setFileBase64] = useState<string>('');
  const { saveBrand } = usePersonaContext();
  const { userData } = useAuthContext();
  const photoID = uuid();
  const FilteredID = photoID.replace(/\D/g, '');
  const slicedPhoto = FilteredID.slice(0, 1);
  const photo = '/icons/nobrand' + slicedPhoto + '.svg';
  const [BrandReplacementArray, setBrandReplacementArray] = useState([
    { replaceThis: '', withThis: '' },
  ]);
  const [BrandAvoidArray, setBrandAvoidArray] = useState(['']);
  const [BrandSparinglyArray, setBrandSparinglyArray] = useState(['']);

  const handleCreate = (inputValue: string) => {
    setLoading(true);
    setTimeout(() => {
      const newOption = createOption(inputValue);
      setLoading(false);
      setOptions((prev) => [...prev, newOption]);
      setValue(newOption);
    }, 1000);
  };

  function validateSize(files: FileList | null) {
    if (files) {
      const fileRef = files[0] || '';
      const fileSize = fileRef.size; // in MiB
      if (fileSize > 780000) {
        alert('File size exceeds 780kb');
        // $(file).val(''); //for clearing with Jquery
      } else {
        // Proceed further
        convertFile(files);
      }
    }
  }

  const InputButton = () => {
    return (
      <div className={styles['imagebutton']}>
        <label
          className={styles['image-label']}
          htmlFor="fileInput"
          id="fileInputLabel"
        >
          Edit Photo
        </label>
        <input
          className={styles['image-input']}
          type="file"
          accept=".png, .jpg, .jpeg, .svg"
          onChange={(e) => validateSize(e.target.files)}
          id="fileInput"
        />
      </div>
    );
  };

  useEffect(() => {
    if (successfulBrandSaved) {
      const resetCopyButtonTextTimeout = setTimeout(() => {
        setSuccessfulBrandSaved(false);
      }, 5000);
      return () => clearTimeout(resetCopyButtonTextTimeout);
    }
  }, [successfulBrandSaved]);

  function convertFile(files: FileList | null) {
    if (files) {
      const fileRef = files[0] || '';
      const fileType: string = fileRef.type || '';
      console.log('This file upload is of type:', fileType);
      const reader = new FileReader();
      reader.readAsBinaryString(fileRef);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      reader.onload = (ev: any) => {
        // convert it to base64
        setFileBase64(`data:${fileType};base64,${btoa(ev.target.result)}`);
      };
    }
  }

  useEffect(() => {
    setFileBase64(photo);
  }, []);

  const updateBrandReplacementWords = (newWords: replacementWords[]) => {
    setBrandReplacementArray(newWords);
  };

  const updateBrandNoNoWords = (newWords: string[]) => {
    setBrandAvoidArray(newWords);
  };

  const updateBrandUseSparinglyWords = (newWords: string[]) => {
    setBrandSparinglyArray(newWords);
  };

  const BrandPersonaSchema = yup.object({
    brand: yup.string().required('Please enter a brand name'),
    description: yup.string().required('Please enter a description'),
    tone: yup.array().required('Please select at least one tone.'),
  });

  return (
    <>
      {' '}
      <Formik
        initialValues={{
          brand: '',
          website: '',
          description: '',
          industry: '',
          tone: [''],
          profilePic: '',
          brandPositioning: '',
          brandReplacementWords: [{ replaceThis: '', withThis: '' }],
          brandNoNoWords: [''],
          brandUseSparinglyWords: [''],
        }}
        onSubmit={async (values) => {
          setLoading(true);
          const industry = value?.value || '';
          //rename these
          // const BrandPersonaInput: BrandPersonaPopupInput = {
          const brand = values.brand;
          const website = values.website;
          const description = values.description;
          const brandPositioning = values.brandPositioning;
          const tone = values.tone.filter((e) => e.length);
          const profilePic = filebase64 ?? photo;
          const brandReplacementWords = BrandReplacementArray.filter(
            (item) => item.replaceThis !== ''
          );
          const brandNoNoWords = BrandAvoidArray.filter((item) => item !== '');
          const brandUseSparinglyWords = BrandSparinglyArray.filter(
            (item) => item !== ''
          );
          // };
          await saveBrand({
            brand,
            website,
            description,
            brandPositioning,
            industry,
            tone,
            profilePic,
            brandReplacementWords,
            brandNoNoWords,
            brandUseSparinglyWords,
          });
          setLoading(false);
          setSuccessfulBrandSaved(true);
          onClose();
          console.log('closed');
          mixpanel.track('Brand Persona Saved', {
            brand: brand,
            response: {
              brand,
              website,
              description,
              industry,
              brandPositioning,
              tone,
              profilePic,
              brandReplacementWords,
              brandNoNoWords,
              brandUseSparinglyWords,
            },
            email: userData?.email,
            displayName: userData?.displayName,
          });
        }}
        validationSchema={BrandPersonaSchema}
      >
        {(props) => {
          return (
            <>
              <div className={styles['form-popup']}>
                {/* header starts here */}
                <div className={styles['top-header']}>
                  <h3>Brand Persona</h3>
                  <div className={styles['flex2']}>
                    <BasicButton
                      type="button"
                      theme="white"
                      loading={loading}
                      disabled={loading}
                      text={'Cancel'}
                      onClick={() => onClose()}
                    />
                    <BasicButton
                      type="button"
                      theme="dark"
                      loading={loading}
                      disabled={loading}
                      image={{
                        src: '/icons/Playlist.svg',
                        height: 14,
                        width: 14,
                      }}
                      text={
                        successfulBrandSaved ? 'Brand Saved!' : 'Save Persona'
                      }
                      onClick={() => props.handleSubmit()}
                    />
                  </div>
                </div>
                {/* header ends here */}
                {/* start of the top */}
                <div className={styles['form-splitter']}>
                  <div className={styles['left-side']}>
                    <div className={styles['input-container-top']}>
                      <div className={styles['brand-image']}>
                        <div className={styles['brand-website']}>
                          <div className={styles['small-input']}>
                            <BasicInput
                              id="brand-persona-input"
                              disabled={false}
                              label={<h2>Brand Name</h2>}
                              placeholder="Brand Name"
                              setValue={props.handleChange('brand')}
                              touched={props.touched.brand ? true : false}
                              onBlur={props.handleBlur}
                              value={props.values.brand}
                            />
                          </div>
                          <div className={styles['small-input2']}>
                            <BasicInput
                              id="brand-persona-input"
                              disabled={false}
                              label={<h2>Brand's URL</h2>}
                              placeholder="Company Website (Optional)"
                              setValue={props.handleChange('website')}
                              touched={props.touched.website ? true : false}
                              onBlur={props.handleBlur}
                              value={props.values.website}
                            />
                          </div>
                        </div>
                        <div className={styles['image-upload']}>
                          <div className={styles['image-border']}>
                            <Image
                              src={filebase64 ? filebase64 : photo}
                              alt="Close"
                              layout="fixed"
                              objectFit="contain"
                              height={98}
                              width={98}
                              className={styles['image']}
                            />
                          </div>
                          <div className={styles['imagebutton']}>
                            <InputButton />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* end of top */}
                    {/* <div className={styles['divider']}></div> */}
                    <div className={styles['input-container']}>
                      <div className={styles['text-area']}>
                        <div className={styles['header3']}>
                          <h2>What Industry is it in?</h2>
                        </div>
                        <div className={styles['creatable']}>
                          <CreatableSelect
                            isClearable
                            isDisabled={loading}
                            isLoading={loading}
                            placeholder={'Select or Type the Industry.'}
                            onChange={(newValue) => setValue(newValue)}
                            onCreateOption={handleCreate}
                            options={options}
                            value={value}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={styles['input-container']}>
                      <div className={styles['text-area']}>
                        <BasicButtonSelectionInput
                          isMultipleSelection
                          allowUserInput
                          id="tone"
                          label={
                            <div>
                              <h3>What is the brand's tone of voice?</h3>
                              <p>Select all that apply</p>
                            </div>
                          }
                          defaultOptions={emailDefaultToneOptions}
                          // defaultOptionIcons={defaultSocialIcon}
                          value={props.values.tone}
                          disabled={loading}
                          errors={props.errors.tone as string}
                          touched={props.touched.tone ? true : false}
                          onBlur={props.handleBlur}
                        />
                      </div>
                    </div>
                    <div className={styles['input-container']}>
                      <div className={styles['text-area']}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                          }}
                        >
                          <div className={styles['header2']}>
                            <h3>Quick Description</h3>
                          </div>
                          <Tooltip
                            tooltipText="A brief summary of your brand’s identity and mission."
                            style={{
                              marginLeft: '-5px',
                              position: 'relative',
                              top: '-2px',
                            }}
                          />
                        </div>
                        <BoxedAutoResizeTextarea
                          id="textarea"
                          label={
                            <div>
                              <p>Provide a description of the brand.</p>
                            </div>
                          }
                          placeholder="An AI Writing tool that creates copy that resonates with targeted audience."
                          value={props.values.description}
                          setValue={props.handleChange('description')}
                          disabled={loading}
                          errors={props.errors.description as string}
                          touched={props.touched.description ? true : false}
                          onBlur={props.handleBlur}
                          extraSmall={true}
                        />
                      </div>
                    </div>

                    <div className={styles['input-container']}>
                      <div className={styles['text-area']}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                          }}
                        >
                          <div className={styles['header2']}>
                            <h3>Brand Positioning</h3>
                          </div>
                          <Tooltip
                            tooltipText="Your brand's standout qualities—what makes you different from competitors."
                            style={{
                              marginLeft: '-5px',
                              position: 'relative',
                              top: '-2px',
                            }}
                          />
                        </div>
                        <BoxedAutoResizeTextarea
                          id="textarea"
                          label={
                            <div>
                              <p>
                                Provide the unique value that the brand presents
                                to their customers.
                              </p>
                            </div>
                          }
                          placeholder="Understanding your audience and how to talk to them."
                          value={props.values.brandPositioning}
                          setValue={props.handleChange('brandPositioning')}
                          disabled={loading}
                          errors={props.errors.brandPositioning as string}
                          touched={
                            props.touched.brandPositioning ? true : false
                          }
                          onBlur={props.handleBlur}
                          extraSmall={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={styles['right-side']}>
                    <div className={styles['right-side-inside']}>
                      <div className={styles['input-container']}>
                        <BrandDictionary
                          brandReplacementWords={
                            props.values.brandReplacementWords
                          }
                          brandNoNoWords={props.values.brandNoNoWords}
                          brandUseSparinglyWords={
                            props.values.brandUseSparinglyWords
                          }
                          updateBrandReplacementWords={
                            updateBrandReplacementWords
                          }
                          updateBrandNoNoWords={updateBrandNoNoWords}
                          updateBrandUseSparinglyWords={
                            updateBrandUseSparinglyWords
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </Formik>
    </>
  );
};
